import React, { useState, useEffect } from 'react'
import resources from '../../../services'
import Btn from '../../../ui/Btn'
import Select from 'react-select'
import { Field } from '../../../ui/Field'
import CreatePage from '../../../composents/CreatePage'

const title = 'Meters'
const headers = {
  icon: 'feather icon-plus',
  title: title,
  description: 'creation of new meter',
  breadcrumbs: [
    {
      title: title,
      link: '/meters/meters',
    },
  ],
}

export const ROLES = [
  {
    value: 'Coordinator',
    label: 'Coordinator',
  },
  {
    value: 'Single',
    label: 'Single',
  },
  {
    value: 'Combined',
    label: 'Combined',
  },
]

export const OWNER = [
  {
    value: 'Public',
    label: 'Public',
  },
  {
    value: 'Private',
    label: 'Private',
  },
]

export const SPECS = [
  {
    value: 'direct|wireless|NC|30L/m',
    label: 'direct|wireless|NC|30L/m',
  },
  {
    value: 'direct|wired|NC|30L/m',
    label: 'direct|wired|NC|30L/m',
  },
  {
    value: 'battery|wired|BS|30L/m',
    label: 'battery|wired|BS|30L/m',
  },
]

const MESSAGE = {
  1: 'infos generales',
  2: 'Configuration',
}

export default function CreateMeter() {
  const [loader, setLoader] = useState(false),
    [errors, setErrors] = useState({}),
    [meters, setMeters] = useState([]),
    [step, setStep] = useState(1),
    [serialNumber, setSerialNumber] = useState(''),
    [meterName, setMeterName] = useState(''),
    [clients, setClients] = useState([]),
    [client, setClient] = useState(null),
    [consumers, setConsumers] = useState(null),
    [consumer, setConsumer] = useState(null),
    [group, setGroup] = useState(),
    [ownership, setOwnership] = useState({
      value: 'Public',
      label: 'Public',
    })

  async function onGet() {
    let clientsFromApi = await resources.customer
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (clientsFromApi.status === 200) {
      let covertaToLabelValue = []
      clientsFromApi.data.docs.forEach((el) => {
        covertaToLabelValue.push({
          value: el.id,
          label: el.name,
        })
      })
      setClients(covertaToLabelValue)
    }

    let groupFromApi = await resources.groupOfMeter
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (groupFromApi.status === 200) {
      let covertaToLabelValue = []

      groupFromApi.data.docs.forEach((el) => {
        covertaToLabelValue.push({
          value: el.id,
          label: el.name,
          client: el?.client?.id,
          zone: el?.zone?.zone,
        })
      })
      setMeters(covertaToLabelValue)
    }

    let consumers = await resources.consumer
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (consumers.status === 200) {
      let covertToLabelValue = []
      consumers.data.docs.forEach((el) => {
        covertToLabelValue.push({
          value: el.id,
          label: el.surname,
          client: el.client?.id,
        })
      })
      setConsumers(covertToLabelValue)
    }
  }

  useEffect(() => {
    onGet()
  }, [])

  /**
   * @param {React.FormEvent<HTMLFormElement>} e
   */
  async function onCreate(e) {
    e.preventDefault()
    let formData = new FormData(e.target)
    let object = {}
    formData.forEach((value, key) => (object[key] = value))
    if (group) object.group = group.value
    if (client) object.client = client.value
    if (consumer) object.consumer = consumer.value
    object.ownership = ownership.value
    object.numero_de_serie = serialNumber
    object.meter_name = meterName
    setLoader(true)
    setErrors({})
    let res = await resources.meter
      .create(object)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (res.status === 200) {
      sessionStorage.setItem('success', true)
      window.location.replace('/meters/meters')
    } else if (res.status === 422) {
      const errors = res.data.errors.reduce((acc, error) => {
        return { ...acc, [error.field]: error.message }
      }, {})
      if (
        'client' in errors ||
        'ownership' in errors ||
        'numero_de_serie' in errors ||
        'meter_name' in errors ||
        'zone' in errors
      ) {
        setStep(1)
      }
      setErrors(errors)
    } else if (res.status === 403) {
      setErrors({ not_autorized: true })
    }
    setLoader(false)
  }

  const filterGroup = () => {
    let all_groups = []

    if (client) {
      all_groups = meters.filter((e) => e.client === client.value)
    }
    return all_groups
  }

  const canGoToTheNextStep = () => {
    if (step === 1) {
      return (
        ownership === null || client === null || serialNumber.length === 0 || meterName.length === 0
      )
    }
    return false
  }

  const filterConsumers = () => {
    let all_consumers = []

    if (client) {
      all_consumers = consumers.filter((e) => e.client === client.value)
    }
    return all_consumers
  }

  return (
    <CreatePage show_error={errors['not_autorized']} headers={headers}>
      <form onSubmit={onCreate}>
        <div className="row justify-content-center mt-3 mb-3">
          <div className="col-lg-6 ">
            <div className="card">
              <div className="card-header">
                <h5>{MESSAGE[step]}</h5>
              </div>
              <div className="card-body">
                {step === 1 && (
                  <>
                    <div className="mb-3">
                      <label htmlFor="exampleInputEmail1" className="form-label">
                        Client <span style={{ color: 'red' }}>*</span>
                      </label>
                      <Select
                        onChange={(e) => {
                          setConsumer(null)
                          setClient(e)
                        }}
                        options={clients}
                        isSearchable
                        isClearable
                        value={client}
                        className={errors['client'] ? ' is-invalid' : ''}
                      />
                      {errors['client'] && (
                        <div className="invalid-feedback">{errors['client']}</div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label htmlFor="exampleInputEmail1" className="form-label">
                        Ownership <span style={{ color: 'red' }}>*</span>
                      </label>
                      <Select
                        options={OWNER}
                        isSearchable
                        isClearable={false}
                        value={ownership}
                        onChange={(e) => {
                          setConsumer(null)
                          setOwnership(e)
                        }}
                        className={errors['ownership'] ? ' is-invalid' : ''}
                      />
                      {errors['ownership'] && (
                        <div className="invalid-feedback">{errors['ownership']}</div>
                      )}
                    </div>

                    {ownership?.value === 'Private' && (
                      <div className="mb-3">
                        <label htmlFor="exampleInputEmail1" className="form-label">
                          Consumer <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Select
                          options={filterConsumers()}
                          isSearchable
                          isClearable
                          onChange={setConsumer}
                          className={errors['consumer'] ? ' is-invalid' : ''}
                        />
                        {errors['consumer'] && (
                          <div className="invalid-feedback">{errors['consumer']}</div>
                        )}
                      </div>
                    )}

                    <Field
                      name="numero_de_serie"
                      className="mb-3"
                      error={errors['numero_de_serie']}
                      onChange={(e) => setSerialNumber(e.target.value)}
                      value={serialNumber}
                      required
                    >
                      serial number
                    </Field>

                    <Field
                      onChange={(e) => setMeterName(e.target.value)}
                      value={meterName}
                      name="meter_name"
                      className="mb-3"
                      error={errors['meter_name']}
                      required
                    >
                      Meter name
                    </Field>

                    <div className="mb-3">
                      <label htmlFor="exampleInputEmail1" className="form-label">
                        Meter group
                      </label>
                      <Select
                        options={filterGroup()}
                        isSearchable
                        isClearable
                        name="group"
                        onChange={setGroup}
                        value={group}
                        className={errors['group'] ? ' is-invalid' : ''}
                      />
                      {errors['group'] && <div className="invalid-feedback">{errors['group']}</div>}
                    </div>

                    <Field
                      name="zone"
                      className="mb-3"
                      value={group?.zone}
                      error={errors['zone']}
                      disabled
                    >
                      Zone name
                    </Field>
                  </>
                )}

                {step === 2 && (
                  <>
                    <div className="mb-3">
                      <label htmlFor="exampleInputEmail1" className="form-label">
                        Role <span style={{ color: 'red' }}>*</span>
                      </label>
                      <Select
                        name="role"
                        options={ROLES}
                        isSearchable
                        isClearable
                        className={errors['role'] ? ' is-invalid' : ''}
                      />
                      {errors['role'] && <div className="invalid-feedback">{errors['role']}</div>}
                    </div>

                    <div className="mb-3">
                      <label name="typeOfNetwork" htmlFor="typeOfNetwork" className="form-label">
                        Network mode
                        <span style={{ color: 'red' }}>*</span>
                      </label>
                      <select
                        name="typeOfNetwork"
                        className={
                          errors['typeOfNetwork'] ? 'form-select is-invalid' : 'form-select'
                        }
                        aria-label="Default select example"
                      >
                        <option value="wifi">wifi</option>
                        <option value="wifi mesh">wifi mesh</option>
                        <option value="Bluetooth">Bluetooth</option>
                        <option value="Bluetooth mesh">Bluetooth mesh</option>
                      </select>
                      {errors['typeOfNetwork'] && (
                        <div className="invalid-feedback">{errors['typeOfNetwork']}</div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label htmlFor="typeOfNetworkTopo" className="form-label">
                        Network topology
                        <span style={{ color: 'red' }}>*</span>
                      </label>
                      <select
                        className={
                          errors['typeOfNetworkTopo'] ? 'form-select is-invalid' : 'form-select'
                        }
                        aria-label="Default select example"
                        name="typeOfNetworkTopo"
                      >
                        <option value="Wifi AP">Wifi AP</option>
                        <option value="Mesh network">Mesh network</option>
                        <option value="Start network">Start network</option>
                        <option value="Coordinator">Coordinator</option>
                      </select>
                      {errors['typeOfNetworkTopo'] && (
                        <div className="invalid-feedback">{errors['typeOfNetworkTopo']}</div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label htmlFor="workingMode" className="form-label">
                        Working Mode
                        <span style={{ color: 'red' }}>*</span>
                      </label>
                      <select
                        className={errors['workingMode'] ? 'form-select is-invalid' : 'form-select'}
                        aria-label="Default select example"
                        name="workingMode"
                      >
                        <option value="Unique mode">Unique mode</option>
                        <option value="Dual mode">Dual mode</option>
                        <option value="Coordinator mode">Coordinator mode</option>
                      </select>
                      {errors['workingMode'] && (
                        <div className="invalid-feedback">{errors['workingMode']}</div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label htmlFor="exampleInputEmail1" className="form-label">
                        System Specs
                      </label>
                      <Select
                        name="systemSpecs"
                        options={SPECS}
                        isSearchable
                        isClearable
                        className={errors['systemSpecs'] ? ' is-invalid' : ''}
                      />
                      {errors['systemSpecs'] && (
                        <div className="invalid-feedback">{errors['systemSpecs']}</div>
                      )}
                    </div>

                    <Field name="sysVersion" className="mb-3" required error={errors['sysVersion']}>
                      System Version
                    </Field>

                    <Field name="note" className="mb-3" error={errors['note']}>
                      More Details
                    </Field>
                  </>
                )}

                <div className="row ">
                  {step !== 1 && (
                    <div className="col-lg-6">
                      <div className="d-grid gap-2">
                        <Btn
                          class="btn waves-effect waves-light btn-primary"
                          onLoad={loader}
                          onClick={(e) => {
                            e.preventDefault()
                            setStep((value) => value - 1)
                          }}
                        >
                          <i className="feather icon-arrow-left"></i> Back
                        </Btn>
                      </div>
                    </div>
                  )}
                  <div className={`col-lg-${step === 1 ? '12' : '6'}`}>
                    <div className="d-grid gap-2">
                      <Btn
                        onClick={(e) => {
                          if (step !== 2) {
                            e.preventDefault()
                            setStep((value) => value + 1)
                          }
                        }}
                        disabled={canGoToTheNextStep()}
                        class="btn waves-effect waves-light btn-primary"
                        onLoad={loader}
                      >
                        <i
                          className={`feather ${step !== 2 ? 'icon-arrow-right' : 'icon-save'}`}
                        ></i>{' '}
                        {step === 1 ? 'Next' : 'Submit'}
                      </Btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </CreatePage>
  )
}
